import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";

import { db } from "../firebase";
import { useParams } from "react-router-dom";

function RSVP() {

  const { spacelink } = useParams();

  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadResponses();
  }, [spacelink]);

  const loadResponses = async () => {

    try {

      // ✅ FIXED COLLECTION NAME
      const q = query(
        collection(db, "rsvps"),
        where("spacelink", "==", spacelink)
      );

      const snap = await getDocs(q);

      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // newest first
      data.sort((a, b) => b.createdAt - a.createdAt);

      setResponses(data);

    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  if (loading) {
    return (
      <div style={styles.center}>
        Loading...
      </div>
    );
  }

  return (
    <div style={styles.page}>

      <h1 style={styles.title}>
        RSVP Responses
      </h1>

      {responses.length === 0 ? (

        <p style={{ textAlign: "center" }}>
          No responses yet.
        </p>

      ) : (

        responses.map((rsvp) => (

          <div key={rsvp.id} style={styles.card}>

            {/* YES / NO BADGE */}
            <div
              style={styles.badge(
                rsvp.response === "yes"
                  ? "#2e7d32"
                  : "#c62828"
              )}
            >
              {rsvp.response === "yes"
                ? "ATTENDING"
                : "DECLINED"}
            </div>

            {/* GUESTS */}
            <h3 style={{ marginBottom: "10px" }}>
              Guests
            </h3>

            {rsvp.names?.map((name, i) => (
              <p key={i}>
                • {name}
              </p>
            ))}

            {/* MESSAGE */}
            {rsvp.message && (
              <>
                <h4 style={{ marginTop: "20px" }}>
                  Message
                </h4>

                <p>{rsvp.message}</p>
              </>
            )}

            {/* DATE */}
            <small style={styles.date}>
              {new Date(
                rsvp.createdAt
              ).toLocaleString()}
            </small>

          </div>
        ))
      )}

    </div>
  );
}

export default RSVP;

const styles = {

  page: {
    height: "100vh",
    width: "100%",
    padding: "30px",
    overflowY: "auto"
  },

  center: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  title: {
    textAlign: "center",
    marginBottom: "30px",
    fontSize: "32px",
    fontWeight: "700",
  },

  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "16px",
    marginBottom: "20px",
    position: "relative",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },

  badge: (bg) => ({
    position: "absolute",
    top: "15px",
    right: "15px",
    background: bg,
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: "bold",
  }),

  date: {
    display: "block",
    marginTop: "20px",
    opacity: 0.6,
  },
};